export default {
  data () {
    return {
      mixFiltersFields: {},
      mixFiltersConfig: {}
    }
  },
  methods: {
    // METHODS
    mixApplyFilter () {
      this.mixHookOnFilter(this._mixCreateFilterValue())
    },
    mixHookOnFilter (filterValue) {

    },
    _mixCreateFilterValue () {
      let items = Object.keys(this.mixFiltersFields)
        // Parse To model
        .map((field) => {
          let model = this.copyObjectProps(this._mixGetModelConfig(), this.mixFiltersConfig[field] || {})
          let valueTemplate = this.checkEs6AndRun(model.valueTemplate, { value: this.mixFiltersFields[field] })
          return {
            ...model,
            field,
            valueTemplate
          }
        })
        .filter(({ valueTemplate }) => {
          return valueTemplate
        })
        // Create a value for each filter
        .map(({ template, field, valueTemplate }) => {
          let data = {
            field,
            value: valueTemplate
          }
          return `${this.checkEs6AndRun(template, data)}`
        })
        .filter((value) => value)
        .map((value) => {
          return `( ${value} )`
        })

      return items.join(' && ')
    },
    _mixGetModelConfig () {
      return {
        field: null,
        valueTemplate: (data) => data.value,
        template: (data) => `${data.field}.contains("${data.value}")`
      }
    }
  }
}
